import Modal from "shared/components/Modal";
import Button from "shared/components/Button";
import { usePoiCreate } from "./usePoiCreate";
import { useCallback } from "react";

interface PoiCreateProps {}

const PoiCreate: React.FC<PoiCreateProps> = () => {
  const [modalOpen, setModalOpen, loading, poiCreate] = usePoiCreate();

  const closeModal = useCallback(() => {
    // TODO: Cancel POI Add process
    setModalOpen(false);
  }, [setModalOpen]);

  return (
    <Modal
      open={modalOpen}
      closeModal={closeModal}
      btnsDisabled={loading}
      closeDisabled={loading}
      showSpinner={loading}
      title="Add Scout Point"
      underlayClass="FaintUnderlay"
      actionButton={
        <Button
          colour="ThemeAlt"
          additionalClassNames="PrimaryButton Large ThemeText"
          onClick={poiCreate}
          disabled={loading}
        >
          Add
        </Button>
      }
    >
      <p>Are you sure you want to add the Scout Point here?</p>
    </Modal>
  );
};

export default PoiCreate;
